<template>
  <v-col cols="12" class="pa-0 pl-5 pr-5">
    <v-sheet rounded="lg">
      <v-container fluid>
        <h1>Pacotes de Ingressos</h1>
        <paragrafo>
          Nesta tela, você pode encontrar pacotes de ingressos que já foram
          cadastrados. Além disso, é possível cadastrar novos pacotes e realizar
          alterações através do ícone de lápis. Caso necessário, você também
          pode excluir os pacotes selecionados.
        </paragrafo>
        <paragrafo
          >A grade de exibição traz informações pertinentes acerca dos pacotes,
          tais como a data de registro, o nome do comprador, o valor total da
          compra, a quantidade de itens inclusos e a forma de pagamento
          utilizada. Adicionalmente, você tem a opção de realizar ações como
          ajustar os detalhes específicos do pacote ou então excluí-lo, conforme
          se faça necessário.</paragrafo
        >
        <negrito></negrito>
        <imagem :src="image_1" />
        <paragrafo
          >Para criar um novo registro, clique na opção "Novo Pacote". Nessa
          etapa, é crucial completar os campos obrigatórios conforme descritos
          abaixo:</paragrafo
        >
        <paragrafo><negrito>VENDA DIRETA</negrito></paragrafo>
        <ul>
          <li>
            <negrito>Comprador</negrito>: Selecione o comprador (cadastrar o
            comprador em Lojas > Consumidores);
          </li>
          <li>
            <negrito>Percentual de Desconto</negrito>: Insira a taxa de desconto
            a ser aplicada;
          </li>
          <li><negrito>Status</negrito>: Indique o estado atual do pacote;</li>
          <li>
            <negrito>Método de Pagamento</negrito>: Selecione o método de
            pagamento empregado.
          </li>
        </ul>
        <imagem :src="image_2" />
        <paragrafo
          >Em seguida, proceda à adição do(s) produto(s) seguindo estas
          etapas:</paragrafo
        >
        <ul>
          <li>
            <negrito>Adicionar Produto</negrito>: Clique na opção “Adicionar
            produto”;
          </li>
          <li>
            <negrito>Seleção de Produto</negrito>: Selecione o produto desejado;
          </li>
          <li>
            <negrito>Quantidade</negrito>: Indique a quantidade necessária;
          </li>
          <li>
            <negrito>Adicionar ao Pacote</negrito>:Clique para “adicionar ao
            pacote" para finalizar inclusão deste produto.
          </li>
        </ul>
        <imagem :src="image_3" />
        <paragrafo
          >Uma vez que todos os produtos desejados tenham sido inseridos, não se
          esqueça de salvar. Ao fazê-lo, o pacote será incluído e,
          adicionalmente, a tela para inserção dos portadores e para o envio do
          conjunto de ingressos será apresentada.</paragrafo
        >
        <imagem :src="image_4" />
        <paragrafo
          >Quanto às opções de envio, que podem ser realizadas por E-mail,
          WhatsApp e SMS, é possível efetuá-las das seguintes
          maneiras:</paragrafo
        >
        <ul>
          <li>
            <negrito>Envio Único</negrito>: Nessa abordagem, o envio é
            direcionado exclusivamente ao comprador. Todos os ingressos são
            compactados em um arquivo ZIP. Esse arquivo, contendo todos os
            ingressos adquiridos, será enviado ao comprador por meio do canal
            escolhido (E-mail, WhatsApp ou SMS);
          </li>
          <li>
            <negrito>Envio Múltiplo</negrito>: Sob essa alternativa, o envio é
            realizado para os dados cadastrados em cada ingresso
            individualmente. Assim, os ingressos são transmitidos para cada
            portador separadamente, utilizando as informações registradas no
            momento do cadastro. O processo ocorre por meio do canal escolhido
            (E-mail, WhatsApp ou SMS);
          </li>
          <li>
            <negrito>Envio Individual</negrito>: Nesta alternativa, a
            transmissão é direcionada exclusivamente ao portador escolhido,
            possibilitando o envio através dos canais de E-mail, WhatsApp ou
            SMS.
          </li>
        </ul>
        <paragrafo
          >Para concluir o registro, é necessário selecionar a opção "Salvar e
          Enviar". Ao optar por essa ação, o sistema procederá automaticamente
          com o envio conforme a seleção previamente efetuada.</paragrafo
        >
        <imagem :src="image_5" />
        <paragrafo><negrito>Venda CORTESIA</negrito></paragrafo>
        <ul>
          <li>
            <negrito>Comprador</negrito>: Selecione o comprador (cadastrar o
            comprador em Lojas > Consumidores);
          </li>
          <li><negrito>Status</negrito>: Indique o estado atual do pacote;</li>
          <li>
            <negrito>Método de Pagamento</negrito>: Selecione o método de
            pagamento empregado.
          </li>
        </ul>
        <imagem :src="image_6" />
        <paragrafo
          >Em seguida, proceda à adição do(s) produto(s) seguindo estas
          etapas:</paragrafo
        >
        <ul>
          <li>
            <negrito>Adicionar Produto</negrito>: Clique na opção “Adicionar
            produto”;
          </li>
          <li>
            <negrito>Seleção de Produto</negrito>: Selecione o produto desejado;
          </li>
          <li>
            <negrito>Quantidade</negrito>: Indique a quantidade necessária;
          </li>
          <li>
            <negrito>Adicionar ao Pacote</negrito>:Clique para “adicionar ao
            pacote" para finalizar inclusão deste produto.
          </li>
        </ul>
        <paragrafo
          >Uma vez que todos os produtos desejados tenham sido inseridos, não se
          esqueça de salvar. Ao fazê-lo, o pacote será incluído e,
          adicionalmente, a tela para inserção dos portadores e para o envio do
          conjunto de ingressos será apresentada.</paragrafo
        >
        <paragrafo
          >Quanto às opções de envio, que podem ser realizadas por E-mail,
          WhatsApp e SMS, é possível efetuá-las das seguintes
          maneiras:</paragrafo
        >
        <ul>
          <li>
            <negrito>Envio Único</negrito>: Nessa abordagem, o envio é
            direcionado exclusivamente ao comprador. Todos os ingressos são
            compactados em um arquivo ZIP. Esse arquivo, contendo todos os
            ingressos adquiridos, será enviado ao comprador por meio do canal
            escolhido (E-mail, WhatsApp ou SMS);
          </li>
          <li>
            <negrito>Envio Múltiplo</negrito>: Sob essa alternativa, o envio é
            realizado para os dados cadastrados em cada ingresso
            individualmente. Assim, os ingressos são transmitidos para cada
            portador separadamente, utilizando as informações registradas no
            momento do cadastro. O processo ocorre por meio do canal escolhido
            (E-mail, WhatsApp ou SMS);
          </li>
          <li>
            <negrito>Envio Individual</negrito>: Nesta alternativa, a
            transmissão é direcionada exclusivamente ao portador escolhido,
            possibilitando o envio através dos canais de E-mail, WhatsApp ou
            SMS.
          </li>
        </ul>
        <paragrafo
          >Para concluir o registro, é necessário selecionar a opção "Salvar e
          Enviar". Ao optar por essa ação, o sistema procederá automaticamente
          com o envio conforme a seleção previamente efetuada.</paragrafo
        >
        <paragrafo></paragrafo>
        <h2>Planilha de Portadores</h2>
        <paragrafo
          >Para utilizar este recurso deve-se baixar o modelo de planilha de
          portadores, disponível no botão “Exportar modelo”.</paragrafo
        >
        <imagem :src="image_7" />
        <paragrafo>Na planilha, preencha os seguintes campos:</paragrafo>
        <ul>
          <li>Nome do Portador;</li>
          <li>Documento do Portador (Passaporte ou CPF).</li>
        </ul>
        <paragrafo
          >Você também pode incluir as seguintes informações
          adicionais:</paragrafo
        >
        <ul>
          <li>E-mail do Portador;</li>
          <li>Celular do Portador.</li>
        </ul>
        <paragrafo
          >Após concluir o preenchimento, importe a planilha para o sistema. Os
          dados serão automaticamente processados e registrados.</paragrafo
        >
      </v-container>
    </v-sheet>
  </v-col>
</template>
<script>
export default {
  name: "Usuarios",
  components: {
    paragrafo: () => import("@/docs/components/infos/paragrafo.vue"),
    imagem: () => import("@/docs/components/infos/imagem.vue"),
    negrito: () => import("@/docs/components/infos/negrito.vue"),
  },
  data() {
    return {
      image_1: "/imagensAdmin/Vendas/pacingresso1.png",
      image_2: "/imagensAdmin/Vendas/pacingresso2.png",
      image_3: "/imagensAdmin/Vendas/pacingresso3.png",
      image_4: "/imagensAdmin/Vendas/pacingresso4.png",
      image_5: "/imagensAdmin/Vendas/pacingresso5.png",
      image_6: "/imagensAdmin/Vendas/pacingresso6.png",
      image_7: "/imagensAdmin/Vendas/pacingresso7.png",
    };
  },
};
</script>
